export const WAVE_COLOR = "#ffffff";
export const WAVE_AMPLITUDE = 50;
export const WAVE_AMPLITUDE_DEVICES = 25;
export const WAVE_FREQUENCY = 0.03;

export const LOADING_DURATION = 3;
